import { isEmpty } from "lodash"
import { parseRef, scrubUndefined } from "../../firebase"
import { defaultListener, generateId } from '../helper'

export default {
  state: {
    groups: {}
  },
  getters: {
    allGroups: state => {
      return Object.values(state.groups)
        .sort((a, b) => {
          return !!a.isArchived - !!b.isArchived
        })
    },
    filteredGroups: state => ids =>
      Object.values(state.groups).filter(group => ids.includes(group.id)),
    getGroup: (state) => (id) => state.groups[ id ] || {}
  },
  actions: {
    async createGroup({  getters }, data) {
      const {
        label = '',
        description = '',
        division = '',
        uids = [],
      } = data

      const payload = { isArchived: false, label, description, division, uids }
      const sessionTenant = getters.getSessionTenant
      const merge = true
      const groupId = generateId(sessionTenant, 'groups')

      scrubUndefined(payload)

      await this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('groups')
        .doc(groupId)
        .set(payload, { merge })
        .catch(e => console.log(e))
    },
    async updateGroup({ getters }, data) {
      const { label, description, division, uids, isArchived, id } = data
      const payload = { label, description, division, uids, isArchived }
      const sessionTenant = getters.getSessionTenant
      const merge = true
      const groupId = id

      scrubUndefined(payload)

      await this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('groups')
        .doc(groupId)
        .set(payload, { merge })
        .catch(e => console.log(e))

    },
    initGroups({ commit, getters }) {
      const sessionTenant = getters.getSessionTenant

      if (sessionTenant) {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('groups')
          .onSnapshot(
            defaultListener.bind(this, commit, 'ADD_GROUP', 'REMOVE_GROUP'),
            e => console.log(e)
          )
      }

    },
    ensureGroup({ state, commit }, groupId) {
      const group = state.groups[ groupId ] || {}

      if (isEmpty(group)) {
        this.$firebase.firestore()
          .collection('groups')
          .doc(groupId)
          .get()
          .then(ref => {
            const foundGroup = parseRef(ref)

            if (foundGroup) commit('ADD_GROUP', foundGroup)
          })
          .catch(e => console.log(e))
      }
    }
  },
  mutations: {
    ADD_GROUP(state, group) {
      const { id } = group

      if (id) {
        const newState = { ...state.groups }
        newState[ id ] = group
        state.groups = newState
      }
    },
    REMOVE_GROUP(state, id) {
      if (state.groups[ id ]) {
        const newState = { ...state.groups }
        delete newState[ id ]
        state.groups = newState
      }
    }
  },
}
